module.exports = __webpack_public_path__ + "fonts/brandon-medium.2a745fb.ttf";